import type React from 'react';
import { useState } from 'react';
import { NativeSelect } from '@/components/ui/native-select';
import { cn } from '@/lib/utils';

interface SelectOption {
	value: string;
	display: string;
}

interface SelectProps {
	value?: string;
	options: SelectOption[];
	onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
	idx?: number;
	showValidation?: boolean;
	disabled?: boolean;
}

const Select = ({
	value,
	options,
	onChange,
	idx = 0,
	showValidation = false,
	disabled = false
}: SelectProps): React.JSX.Element => {
	const [touched, setTouched] = useState(false);
	const isEmpty = !value || value === '';
	const showError = (touched || showValidation) && isEmpty;

	return (
		<NativeSelect
			className={cn(
				'py-0 md:py-2 h-8 text-[16px] sm:text-xs w-full',
				showError && 'border-destructive'
			)}
			value={value}
			onChange={onChange}
			onBlur={() => setTouched(true)}
			disabled={disabled}
			data-testid={`employee-${idx}-contract-select`}
			required
		>
			{options.map((option) => (
				<option key={option.value} value={option.value}>
					{option.display}
				</option>
			))}
		</NativeSelect>
	);
};

export default Select;
